import { toast } from 'sonner';
import { useMe, useUsageExport } from '@/api/hooks';
import { useCan } from '@/lib/permissions';
import { saveBlob } from '@/lib/download';
import { showMutationError } from '@/lib/mutationError';
import { GatedButton } from '@/components/GatedButton';
import { Icon } from '@/components/Icon';
import { exportFilename, monthLabel } from './usageModel';

/** Downloads the month's CSV (one line per build, for invoicing). Org admins only: others see it disabled with the reason. */
export function ExportButton({ month }: { month: string }) {
  const can = useCan('admin');
  const me = useMe();
  const exporter = useUsageExport();
  const run = () =>
    exporter.mutate(month, {
      onSuccess: (blob) => {
        saveBlob(blob, exportFilename(me.data?.org.slug ?? 'org', month));
        toast.success(`Usage of ${monthLabel(month)} exported`);
      },
      onError: (e) => showMutationError(e, 'Could not export the usage'),
    });
  return (
    <GatedButton data-testid="usage-export" can={can} variant="outline" disabled={exporter.isPending} onClick={run} className="min-h-11 sm:min-h-9">
      <Icon name={exporter.isPending ? 'hourglass_empty' : 'download'} size={18} />
      Export CSV
    </GatedButton>
  );
}
